// 全局颜色配置文件
// 所有颜色都在这里统一管理，方便修改

export const colorTheme = {
  // ===== 主色调（顶部导航栏） =====
  headerPrimaryStart: "#0d1350", // 导航栏起始颜色（科技蓝色）
  headerPrimaryEnd: "#367288", //导航栏结束颜色
  // ===== 背景渐变色（核心优势、发展战略、底部统一使用） =====
  gradientStart: "#0d1350", // 渐变起始色（科技蓝色）
  gradientEnd: "#367288", // 渐变结束色

  // ===== Icon渐变色（经营范围Icon和核心优势Icon统一使用） =====
  iconGradientStart: "#0d1350", // Icon渐变起始色（科技蓝色）
  iconGradientEnd: "#367288", // Icon渐变结束色

  // ===== 辅助色（用于强调和悬停效果） =====
  accent: "#0d1350", // 强调色
  accentLight: "#367288", // 浅色强调色

  // ===== 章节标题颜色（可自定义） =====
  sectionTitleColor: "#131b6c", // 所有section-title的标题颜色（科技蓝色）

  // ===== 固定的文字颜色（不会被调色板改变） =====
  textDark: "#333", // 深色文字
  textMedium: "#555", // 中等深色文字
  textLight: "#666", // 浅色文字
  textWhite: "#ffffff", // 白色文字
};

// 生成CSS变量的函数
export function generateCSSVariables() {
  return `
    :root {
      --header-primary-start: ${colorTheme.headerPrimaryStart};
      --header-primary-end: ${colorTheme.headerPrimaryEnd};
      --gradient-start: ${colorTheme.gradientStart};
      --gradient-end: ${colorTheme.gradientEnd};
      --icon-gradient-start: ${colorTheme.iconGradientStart};
      --icon-gradient-end: ${colorTheme.iconGradientEnd};
      --accent: ${colorTheme.accent};
      --accent-light: ${colorTheme.accentLight};
      --section-title-color: ${colorTheme.sectionTitleColor};
      --text-dark: ${colorTheme.textDark};
      --text-medium: ${colorTheme.textMedium};
      --text-light: ${colorTheme.textLight};
      --text-white: ${colorTheme.textWhite};
    }
  `;
}

// 应用颜色主题到DOM
export function applyColorTheme(theme = colorTheme) {
  const root = document.documentElement;

  // 设置CSS变量
  root.style.setProperty("--header-primary-start", theme.headerPrimaryStart);
  root.style.setProperty("--header-primary-end", theme.headerPrimaryEnd);
  root.style.setProperty("--gradient-start", theme.gradientStart);
  root.style.setProperty("--gradient-end", theme.gradientEnd);
  root.style.setProperty("--icon-gradient-start", theme.iconGradientStart);
  root.style.setProperty("--icon-gradient-end", theme.iconGradientEnd);
  root.style.setProperty("--accent", theme.accent);
  root.style.setProperty("--accent-light", theme.accentLight);
  root.style.setProperty("--section-title-color", theme.sectionTitleColor);
}

// 预设的颜色主题方案
export const presetThemes = {
  // 默认主题（蓝色系）
  // default: {
  //   name: "默认蓝色",
  //   headerPrimaryStart: "#4e6a7a",
  //   headerPrimaryEnd: "#3194b2",
  //   gradientStart: "#4e6a7a",
  //   gradientEnd: "#3194b2",
  //   iconGradientStart: "#4e6a7a",
  //   iconGradientEnd: "#3194b2",
  //   accent: "#31a7d2",
  //   accentLight: "#43b4ea",
  //   sectionTitleColor: "#4e6a7a",
  // },
  // 科技蓝色主题
  default: {
    name: "科技蓝色",
    headerPrimaryStart: "#0d1350",
    headerPrimaryEnd: "#3194b2",
    gradientStart: "#0d1350",
    gradientEnd: "#367288",
    iconGradientStart: "#0d1350",
    iconGradientEnd: "#3194b2",
    accent: "#31a7d2",
    accentLight: "#43b4ea",
    sectionTitleColor: "#131b6c",
  },

  // 绿色主题
  green: {
    name: "清新绿色",
    headerPrimaryStart: "#2d5d4f",
    headerPrimaryEnd: "#3d8b6f",
    gradientStart: "#2d5d4f",
    gradientEnd: "#3d8b6f",
    iconGradientStart: "#2d5d4f",
    iconGradientEnd: "#3d8b6f",
    accent: "#4fa779",
    accentLight: "#6bc491",
    sectionTitleColor: "#2d5d4f",
  },

  // 紫色主题
  purple: {
    name: "优雅紫色",
    headerPrimaryStart: "#5a4d7a",
    headerPrimaryEnd: "#7a5fb2",
    gradientStart: "#5a4d7a",
    gradientEnd: "#7a5fb2",
    iconGradientStart: "#5a4d7a",
    iconGradientEnd: "#7a5fb2",
    accent: "#9576d2",
    accentLight: "#b293ea",
    sectionTitleColor: "#5a4d7a",
  },

  // 橙色主题
  orange: {
    name: "活力橙色",
    headerPrimaryStart: "#7a5d4d",
    headerPrimaryEnd: "#c27850",
    gradientStart: "#7a5d4d",
    gradientEnd: "#c27850",
    iconGradientStart: "#7a5d4d",
    iconGradientEnd: "#c27850",
    accent: "#e89266",
    accentLight: "#f5a87e",
    sectionTitleColor: "#7a5d4d",
  },

  // 深蓝主题
  darkBlue: {
    name: "深邃蓝色",
    headerPrimaryStart: "#2c3e50",
    headerPrimaryEnd: "#3498db",
    gradientStart: "#2c3e50",
    gradientEnd: "#3498db",
    iconGradientStart: "#2c3e50",
    iconGradientEnd: "#3498db",
    accent: "#5dade2",
    accentLight: "#85c1e9",
    sectionTitleColor: "#2c3e50",
  },

  // 红色主题
  red: {
    name: "热情红色",
    headerPrimaryStart: "#7a4d5a",
    headerPrimaryEnd: "#c25070",
    gradientStart: "#7a4d5a",
    gradientEnd: "#c25070",
    iconGradientStart: "#7a4d5a",
    iconGradientEnd: "#c25070",
    accent: "#e86680",
    accentLight: "#f58ca0",
    sectionTitleColor: "#7a4d5a",
  },
};

// 从localStorage加载保存的主题
export function loadThemeFromStorage() {
  const savedTheme = localStorage.getItem("colorTheme");
  if (savedTheme) {
    try {
      const theme = JSON.parse(savedTheme);
      Object.assign(colorTheme, theme);
      applyColorTheme(colorTheme);
      return true;
    } catch (e) {
      console.error("加载主题失败:", e);
      return false;
    }
  }
  return false;
}

// 保存主题到localStorage
export function saveThemeToStorage(theme = colorTheme) {
  try {
    localStorage.setItem("colorTheme", JSON.stringify(theme));
    return true;
  } catch (e) {
    console.error("保存主题失败:", e);
    return false;
  }
}

// 重置为默认主题
export function resetToDefault() {
  Object.assign(colorTheme, presetThemes.default);
  applyColorTheme(colorTheme);
  saveThemeToStorage(colorTheme);
}
